import {
  ColorIcon,
  HStack,
  VStack,
  colors,
  GoiLogo,
  Spacing,
  customEvent,
  ClickEventType,
} from "goi_common";
import Link from "next/link";
import { Box } from "@chakra-ui/react";
import { ReactNode } from "react";

const GoiMessage = ({ title, event }: { title?: ReactNode; event?: ClickEventType }) => {
  // const handleLeftClick = () => {
  //   customEvent({
  //     newGtm: {
  //       path: "home",
  //       trigger_and_target: "goi_msg-uv_fnrl_pre",
  //     },
  //   });
  // };

  // const handleRightClick = () => {
  //   customEvent({
  //     newGtm: {
  //       path: "home",
  //       trigger_and_target: "goi_msg-uv_service",
  //     },
  //   });
  // };

  return (
    <Box width="100%" padding="0 20px 56px">
      <Link
        href="/funeral-prepare/company-introduction/"
        onClick={() => {
          event &&
            customEvent({
              newGtm: {
                path: event.path,
                trigger_and_target: event.trigger_and_target,
              },
            });
        }}
      >
        <HStack
          padding="16px 24px"
          gap="10px"
          width="100%"
          justifyContent="space-between"
          background={colors.warmGray650}
          borderRadius="12px"
        >
          <VStack gap={0}>
            <span className="subtitle_18_sb white">
              {title ? (
                title
              ) : (
                <>
                  고이장례연구소
                  <br />
                  믿을 만한 곳인가요?
                </>
              )}
            </span>
            <Spacing gap={8} />
            <HStack alignItems="center">
              <Box className="body_14_m gray100">더 알아보기</Box>
              <Box transform="rotate(180deg)">
                <ColorIcon name="arrow_forward_ios" color={colors.gray100} width={14} />
              </Box>
            </HStack>
          </VStack>
          <GoiLogo color={colors.white} size={72} />
        </HStack>
      </Link>
    </Box>
  );
};

export default GoiMessage;
